

export class LookupCriteria {
  productAccountNumber: string;
  policyNumber: string;
  postalCode:string
}
